/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBritaxProductRegistrationViewProps } from './britax-product-registration';

export default (props: IBritaxProductRegistrationViewProps) => {
    return <>{props.productRegistrationNode}</>;
};
